// types
export const TCREATE_USER = 'create_user';
export const TUSER_CREATED = 'user_created';
export const TUSER_NOT_CREATED = 'user_not_created';

export const TSOCIAL_LOGIN = 'social_login';
export const TSOCIAL_LOGGED_IN = 'social_logged_in';
export const TSOCIAL_NOT_LOGGED_IN = 'social_not_logged_in';
export const TDOUBLE_SOCIAL_NOT_LOGGED_IN = 'double_social_not_logged_in';
export const TLINK_SOCIAL_ACNTS_CREDS = 'link_social_accounts_creds';

export const TFBASE_CREATE_USER = 'fbase_create_user';
export const TFBASE_USER_NOT_CREATED = 'fbase_user_not_created';
export const TFBASE_USER_LOGIN = 'fbase_user_login';
export const TFBASE_USER_NOT_LOGGEDIN = 'fbase_user_not_loggedin';

export const TGET_POLLS_TAKEN = 'get_polls_taken';
export const TGET_POLLS_CREATED = 'get_polls_created';

export const TGEN_UNAME = 'gen_uname';
export const TGET_USERNAME = 'get_username';
export const TGET_USERINFO = 'get_userinfo';
export const TGET_MATCH_SCORE = 'get_match_score';
export const TGOT_MATCH_SCORE = 'got_match_score';
export const TMATCH_SCORE_FAIL = 'match_score_fail';

export const TRESET_PDATA = 'reset_poll_data';
export const TRESET_POLL_ERROR = 'reset_poll_error';

export const TGETTING_POLL = 'getting_poll';
export const TGOT_POLL = 'got_poll';
export const TNOT_GOT_POLL = 'not_got_poll';

export const TSEARCHING_POLLS = 'searching_polls';
export const TSEARCHED_POLLS = 'searched_polls';
export const TNOT_SEARCHED_POLLS = 'not_searched_polls';

export const TGETTING_RESULTS = 'getting_poll_results';
export const TGOT_RESULTS = 'got_poll_results';
export const TNOT_GOT_RESULTS = 'not_got_poll_results';
export const TRESET_RESULTS = 'reset_poll_results';

export const TVOTING = 'voting_for_poll';
export const TVOTED = 'voted_for_poll';
export const TNOT_VOTED = 'not_voted_for_poll';
export const TVOTE_POLL = 'vote_poll';

export const TGETTING_RAND_POLL = 'getting_random_poll';
export const TGOT_RAND_POLL = 'got_random_poll';
export const TNOT_GOT_RAND_POLL = 'not_got_random_poll';

export const TCREATING_POLL = 'creating_poll';
export const TCREATED_POLL = 'created_poll';
export const TNOT_CREATED_POLL = 'not_created_poll';

export const TDELETING_POLL = 'deleting_poll';
export const TDELETED_POLL = 'deleted_poll';
export const TNOT_DELETED_POLL = 'not_deleted_poll';

export const TEDIT_POLL = 'edit_poll';
export const TGET_POLL_RES = 'get_poll_results';
// export const TVOTE_POLL = 'vote_poll';

export const TGETTING_TWTS = 'getting_tweets';
export const TGOT_TWTS = 'got_tweets';
export const TNOT_GOT_TWTS = 'not_got_tweets';

export const TUPDATING_USER = 'updating_user';
export const TUSER_UPDATED = 'user_updated';
export const TUSER_NOT_UPDATED = 'user_not_updated';

export const TFOLLOWING_USER = 'following_user';
export const TUSER_FOLLOWED = 'user_followed';
export const TUSER_NOT_FOLLOWED = 'user_not_followed';

export const TGETTING_FOLLOWING = 'getting_following';
export const TGOT_FOLLOWING = 'got_following';
export const TNOT_GOT_FOLLOWING = 'not_got_following';

export const TRESET_ERR = 'reset_error';
export const TLOGGING_OUT_USER = 'loggingout_user';
export const TLOGGED_OUT_USER = 'loggedout_user';
export const TNOT_LOGGED_OUT_USER = 'not_loggedout_user';

export const REQ_S3_URL_START = 'req_s3_url_start';
export const REQ_S3_URL_FAILED = 'req_s3_url_failed';

export const S3_UPLOAD_SUCCESS = 's3_upload_success';
export const S3_UPLOAD_FAILED = 's3_upload_failed';



// WEBPACK FOOTER //
// ./src/actions/types.js